import { AnimatePresence } from 'framer-motion'
import { useModal } from '@velasca/hooks/use-modal'
import {
  CloseColumn,
  Content,
  GlobalStyle,
  Shadow,
  StyledRcDrawer,
} from './Drawer.styles'
import type { DrawerProps } from './Drawer.types'
import { Header } from './Header/Header'

const Drawer = ({
  children,
  className,
  isOpen,
  close,
  sideChildren,
  placement = 'right',
}: DrawerProps): JSX.Element => {
  useModal({
    autoLock: isOpen,
    close,
  })

  return (
    <>
      <GlobalStyle />
      <StyledRcDrawer
        className={className}
        id="drawer"
        open={isOpen}
        placement={placement}
        // We pass unexpected value to not trigger rc-drawer's default width
        // @ts-expect-error
        width={null}
        mask={false}
        motion={(drawerPlacement) => {
          return {
            motionName: `panel-motion-${drawerPlacement}`,
          }
        }}
      >
        {children}
      </StyledRcDrawer>
      <AnimatePresence>
        {isOpen && (
          <Shadow
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2, ease: 'easeInOut' }}
          >
            <CloseColumn
              placement={placement}
              onClick={(e) => {
                // e.preventDefault()
                if (e.target === e.currentTarget) {
                  close()
                }
              }}
            >
              {sideChildren}
            </CloseColumn>
          </Shadow>
        )}
      </AnimatePresence>
    </>
  )
}

Drawer.Header = Header
Drawer.Content = Content

export { Drawer }
